<template>
  <div>
    <Tabs :act="curActPage" :panes="panes" @del="onTabDel" @delAll="onTabDelAll" />
  </div>
</template>

<script>
import mainBus from '@/micro/eventBus';
import Tabs from './children/Tabs.vue';

export default {
  name: 'OmsTabs',
  components: { Tabs },
  data() {
    return {};
  },
  watch: {
    '$route.fullPath': {
      handler() {
        this.addRoute();
      },
      immediate: true,
    },
    'panes.length': {
      handler() {
        if (this.panes.length === 0) {
          this.$router.push('/');
        }
      },
    },
  },
  computed: {
    curActPage() {
      return this.$route.fullPath;
    },
    panes() {
      return this.$store.state.tabs.list;
    },
  },
  created() {
    mainBus.$on('route-change', (info) => {
      this.$store.commit('fixTab', info);
    });
    setTimeout(() => {
      mainBus.$emit('sub-tab', JSON.stringify(this.panes));
    }, 500);
  },
  methods: {
    onTabDel(e) {
      this.$store.commit('delTab', e.index);
      if (e.isCur) {
        this.$nextTick(() => {
          if (this.panes.length > 0) {
            const toIndex = e.index - 1 >= 0 ? e.index - 1 : 0;
            this.$router.push(this.panes[toIndex].path);
          }
        });
      }
      mainBus.$emit('sub-tab', JSON.stringify(this.panes));
    },
    addRoute() {
      const { fullPath, meta: { title = '' } = {} } = this.$route;
      this.$store.commit('addTab', {
        title,
        path: fullPath,
      });
      mainBus.$emit('sub-tab', JSON.stringify(this.panes));
    },
    onTabDelAll() {
      this.$store.commit('delAllTab', this.curActPage);
      mainBus.$emit('sub-tab', JSON.stringify(this.panes));
    },
  },
};
</script>
